module.exports = __webpack_public_path__ + "static/img/s50.e43fa62f.png";